/** State shape passed through ProtectedRoute's Navigate `state.from` */
export interface LocationFrom {
  pathname: string
  search?: string
  hash?: string
}

/** State shape threaded through OIDC state and system selection navigation */
interface ReturnUrlState {
  returnUrl?: string
}

/**
 * Returns true if the URL is a safe relative path.
 * Rejects absolute URLs, protocol-relative URLs, and any scheme.
 */
function isSafeRelativeUrl(url: string): boolean {
  return url.startsWith('/') && !url.startsWith('//')
}

/**
 * Build a sanitized return URL from the ProtectedRoute's `state.from` location.
 * Returns '/' for unsafe or missing values.
 */
export function buildReturnUrl(from?: LocationFrom): string {
  if (!from?.pathname) return '/'
  if (!isSafeRelativeUrl(from.pathname)) return '/'
  if (from.pathname === '/' || from.pathname === '/login') return '/'
  return `${from.pathname}${from.search ?? ''}${from.hash ?? ''}`
}

/**
 * Extract and sanitize a return URL from navigation state (OIDC state or router state).
 * Returns '/' for unsafe or missing values.
 */
export function getReturnUrl(state: unknown): string {
  const returnUrl = (state as ReturnUrlState | null | undefined)?.returnUrl
  if (!returnUrl) return '/'
  if (!isSafeRelativeUrl(returnUrl)) return '/'
  return returnUrl
}
